module.exports = __webpack_public_path__ + "static/media/seminar2.e5036e2b.jpg";